/**
 * Colour theme bootstrap + three-way switch.
 *
 * Loaded render-blocking from <head> so the stored preference lands on <html>
 * before first paint. Deliberately an external file rather than an inline
 * bootstrap: the blog runs under script-src 'self' with no hashes, so an inline
 * script would be blocked.
 *
 * Persistence matches the other properties: localStorage "theme_mode" =
 * auto | light | dark, defaulting to auto.
 *
 * Unlike dbsc.dev this reflects the mode as a data-theme attribute rather than
 * resolving to a single class, because screen.css pairs [data-theme] with a
 * prefers-color-scheme query. That way auto is handled by CSS alone and a
 * reader whose JavaScript never runs still gets their system theme.
 */
(function (window, document) {
    'use strict';

    var STORAGE_KEY = 'theme_mode';
    var MODES = ['auto', 'light', 'dark'];

    var root = document.documentElement;

    // localStorage throws in some privacy modes and sandboxed frames, so read
    // and write both fail soft - the theme falls back to auto.
    function read() {
        try {
            var mode = window.localStorage.getItem(STORAGE_KEY);
            return MODES.indexOf(mode) !== -1 ? mode : 'auto';
        } catch (err) {
            return 'auto';
        }
    }

    function write(mode) {
        try {
            if (mode === 'auto') {
                window.localStorage.removeItem(STORAGE_KEY);
            } else {
                window.localStorage.setItem(STORAGE_KEY, mode);
            }
        } catch (err) {
            // Preference simply won't persist.
        }
    }

    // No attribute means auto, which is what the prefers-color-scheme rules key off.
    function apply(mode) {
        if (mode === 'auto') {
            root.removeAttribute('data-theme');
        } else {
            root.setAttribute('data-theme', mode);
        }
    }

    /* Before first paint. The switch is not in the DOM yet. */
    apply(read());

    function ready(fn) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn);
        } else {
            fn();
        }
    }

    ready(function () {
        var groups = document.querySelectorAll('.gh-theme-switch');
        if (!groups.length) return;

        var buttons = document.querySelectorAll('.gh-theme-switch [data-theme-mode]');

        function render(mode) {
            for (var i = 0; i < buttons.length; i++) {
                buttons[i].setAttribute(
                    'aria-pressed',
                    buttons[i].getAttribute('data-theme-mode') === mode ? 'true' : 'false'
                );
            }
        }

        for (var b = 0; b < buttons.length; b++) {
            buttons[b].addEventListener('click', function () {
                var mode = this.getAttribute('data-theme-mode');
                if (MODES.indexOf(mode) === -1) mode = 'auto';
                write(mode);
                apply(mode);
                render(mode);
            });
        }

        render(read());

        /* Only now is the control live enough to show */
        for (var g = 0; g < groups.length; g++) {
            groups[g].removeAttribute('hidden');
        }
    });
})(window, document);
